(function () {
  'use strict';

  var isUpdating = false;
  var sectionSelector = '[data-smart-cart-page-section]';

  function rootUrl() {
    return window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function formatMoney(cents, currency) {
    var amount = Number(cents || 0);
    var value = amount / 100;
    var code = currency || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    var fractionDigits = amount % 100 === 0 ? 0 : 2;

    try {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: code,
        currencyDisplay: 'symbol',
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: 2
      }).format(value);
    } catch (error) {
      return '$' + value.toFixed(fractionDigits);
    }
  }



  var variantPriceCache = null;

  function getVariantPriceMap() {
    if (variantPriceCache) return variantPriceCache;
    variantPriceCache = {};

    var script = document.querySelector('[data-smart-cart-variant-prices]');
    if (!script) return variantPriceCache;

    try {
      variantPriceCache = JSON.parse(script.textContent || '{}') || {};
    } catch (error) {
      variantPriceCache = {};
    }

    return variantPriceCache;
  }

  function getVariantCompareAt(variantId) {
    var map = getVariantPriceMap();
    if (!variantId || typeof map[String(variantId)] === 'undefined') return 0;
    return Number(map[String(variantId)]) || 0;
  }

  function fetchJson(url, options) {
    var fetchOptions = options || {};
    fetchOptions.credentials = 'same-origin';

    if (window.AbortController) {
      var controller = new AbortController();
      var timeout = window.setTimeout(function () {
        controller.abort();
      }, 12000);

      fetchOptions.signal = controller.signal;

      return fetch(url, fetchOptions).finally(function () {
        window.clearTimeout(timeout);
      });
    }

    return fetch(url, fetchOptions);
  }

  function productImageHtml(product) {
    var image = product && (product.featured_image || (product.images && product.images[0]));
    var src = '';

    if (typeof image === 'string') src = image;
    else if (image && typeof image === 'object') src = image.url || image.src || '';

    if (!src) return '';
    return '<img src="' + src + '" alt="' + escapeHtml(product.title || 'Product') + '" loading="lazy" width="110" height="110">';
  }

  function productPrice(product) {
    if (!product) return 0;
    if (typeof product.price_min !== 'undefined') return product.price_min;
    if (typeof product.price !== 'undefined') return product.price;
    if (product.variants && product.variants.length && typeof product.variants[0].price !== 'undefined') return product.variants[0].price;
    return 0;
  }

  function recommendationCardHtml(product, currency) {
    if (!product) return '';
    var title = product.title || 'Product';
    var url = product.url || '#';

    return (
      '<a class="smart-cart-page-recommendation-card" href="' + url + '">' +
        '<span class="smart-cart-page-recommendation-image">' + productImageHtml(product) + '</span>' +
        '<span class="smart-cart-page-recommendation-body">' +
          '<span class="smart-cart-page-recommendation-title">' + escapeHtml(title) + '</span>' +
          '<span class="smart-cart-page-recommendation-price">' + formatMoney(productPrice(product), currency) + '</span>' +
          '<span class="smart-cart-page-recommendation-cta">View product</span>' +
        '</span>' +
      '</a>'
    );
  }

  function loadCartRecommendations(cart) {
    document.querySelectorAll('[data-smart-cart-page-recommendations-section]').forEach(function (wrap) {
      wrap.hidden = true;
    });
  }

  function getSection() {
    return document.querySelector(sectionSelector);
  }

  function getLine(button) {
    if (!button) return null;
    var line = button.getAttribute('data-line');
    return line ? document.querySelector('[data-smart-cart-page-line="' + line + '"]') : button.closest('[data-smart-cart-page-line]');
  }

  function setLineBusy(button, isBusy) {
    var lineItem = getLine(button);
    if (!lineItem) return;
    lineItem.classList.toggle('is-updating', !!isBusy);
    lineItem.setAttribute('aria-busy', isBusy ? 'true' : 'false');
  }

  function setAllControlsBusy(isBusy) {
    document.querySelectorAll('[data-smart-cart-page-qty-action]').forEach(function (button) {
      button.disabled = !!isBusy;
      if (isBusy) button.setAttribute('aria-busy', 'true');
      else button.removeAttribute('aria-busy');
    });
  }

  function updateCartCount(cart) {
    if (!cart) return;

    var count = cart.item_count || 0;
    [
      '[data-cart-count]',
      '.cart-count',
      '.cart-count-bubble span',
      '#cart-icon-bubble span',
      '.header__cart-count',
      '[data-header-cart-count]'
    ].forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (el) {
        el.textContent = count;
        el.setAttribute('data-count', count);
      });
    });
  }

  function showError(message) {
    var section = getSection();
    if (!section) return;

    var notice = section.querySelector('[data-smart-cart-page-error]');
    if (!notice) {
      notice = document.createElement('div');
      notice.className = 'smart-cart-page-error';
      notice.setAttribute('data-smart-cart-page-error', '');
      notice.setAttribute('role', 'alert');
      section.insertBefore(notice, section.firstChild);
    }

    notice.textContent = message || 'Unable to update cart. Please check the available stock and try again.';
    notice.hidden = false;
  }

  function clearError() {
    document.querySelectorAll('[data-smart-cart-page-error]').forEach(function (notice) {
      notice.hidden = true;
      notice.textContent = '';
    });
  }

  function optionHtml(item) {
    var html = '';

    if (item.options_with_values && item.options_with_values.length) {
      html += item.options_with_values.map(function (option) {
        if (!option || !option.value || option.value === 'Default Title') return '';
        var name = option.name && option.name !== 'Title' ? option.name + ': ' : '';
        return '<div class="smart-cart-page-item-option">' + escapeHtml(name + option.value) + '</div>';
      }).join('');
    } else if (item.variant_title && item.variant_title !== 'Default Title') {
      html += '<div class="smart-cart-page-item-option">' + escapeHtml(item.variant_title) + '</div>';
    }

    if (item.properties) {
      Object.keys(item.properties).forEach(function (key) {
        var value = item.properties[key];
        if (!value || key.charAt(0) === '_') return;
        html += '<div class="smart-cart-page-item-option"><span>' + escapeHtml(key) + ':</span> ' + escapeHtml(value) + '</div>';
      });
    }

    if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan && item.selling_plan_allocation.selling_plan.name) {
      html += '<div class="smart-cart-page-item-option">' + escapeHtml(item.selling_plan_allocation.selling_plan.name) + '</div>';
    }

    return html;
  }

  function lineDiscountsHtml(item, currency) {
    return '';
  }

  function getItemDisplayUnitPrice(item) {
    if (!item) return 0;
    if (typeof item.final_price !== 'undefined') return Number(item.final_price) || 0;
    if (typeof item.original_price !== 'undefined' && Number(item.original_price || 0) > 0) return Number(item.original_price || 0);
    if (typeof item.price !== 'undefined' && Number(item.price || 0) > 0) return Number(item.price || 0);
    var quantity = Number(item.quantity || 1) || 1;
    if (typeof item.original_line_price !== 'undefined') return Math.round(Number(item.original_line_price || 0) / quantity);
    if (typeof item.line_price !== 'undefined') return Math.round(Number(item.line_price || 0) / quantity);
    return 0;
  }

  function unitPriceHtml(item, currency) {
    var current = getItemDisplayUnitPrice(item);
    var compareAt = getVariantCompareAt(item.variant_id);

    var values = '';
    values += '<span class="price smart-cart-page-unit-price-current">' + formatMoney(current, currency) + '</span>';
    if (compareAt > current) {
      values += '<span class="price compare-at smart-cart-page-unit-price-compare">' + formatMoney(compareAt, currency) + '</span>';
    }

    return '<div class="smart-cart-page-unit-price" data-smart-cart-page-unit-price data-variant-id="' + escapeHtml(item.variant_id || '') + '" aria-label="Unit price">' +
      '<span class="smart-cart-page-unit-price-values">' + values + '</span>' +
      '</div>';
  }

  function lineTotalHtml(item, currency) {
    return '';
  }

  function itemImageHtml(item) {
    var title = item.product_title || item.title || 'Product';
    var image = item.image || '';

    if (!image) return '';
    return '<img src="' + image + '" alt="' + escapeHtml(title) + '" loading="lazy" width="80" height="80">';
  }

  function itemHtml(item, index, currency) {
    var line = index + 1;
    var title = item.product_title || item.title || 'Product';
    var url = item.url || rootUrl() + 'cart';
    var options = optionHtml(item);
    var discounts = lineDiscountsHtml(item, currency);

    return (
      '<div class="smart-cart-page-item" role="row" aria-rowindex="' + line + '" data-smart-cart-page-line="' + line + '">' +
        '<button class="smart-cart-page-remove" type="button" data-smart-cart-page-qty-action="remove" data-line="' + line + '" data-quantity="' + item.quantity + '" aria-label="Remove ' + escapeHtml(title) + '">×</button>' +
        '<a class="smart-cart-page-item-image" href="' + url + '" aria-label="' + escapeHtml(title) + '">' + itemImageHtml(item) + '</a>' +
        '<div class="smart-cart-page-item-meta" role="cell">' +
          '<a class="smart-cart-page-item-title" href="' + url + '">' + escapeHtml(title) + '</a>' +
          options +
          unitPriceHtml(item, currency) +
          discounts +
        '</div>' +
        '<div class="smart-cart-page-item-qty" role="cell">' +
          '<div class="smart-cart-page-qty-row">' +
            '<div class="smart-cart-page-qty" aria-label="Quantity controls for ' + escapeHtml(title) + '">' +
              '<button class="smart-cart-page-qty-button" type="button" data-smart-cart-page-qty-action="minus" data-line="' + line + '" data-quantity="' + item.quantity + '" aria-label="Decrease quantity">−</button>' +
              '<span class="smart-cart-page-qty-value" data-smart-cart-page-qty-value>' + item.quantity + '</span>' +
              '<button class="smart-cart-page-qty-button" type="button" data-smart-cart-page-qty-action="plus" data-line="' + line + '" data-quantity="' + item.quantity + '" aria-label="Increase quantity">+</button>' +
            '</div>' +
          '</div>' +
          lineTotalHtml(item, currency) +
        '</div>' +
      '</div>'
    );
  }

  function discountRowsHtml(cart, currency) {
    var rows = [];
    (cart.items || []).forEach(function (item) { (item.line_level_discount_allocations || []).forEach(function (allocation) { rows.push({title:allocation.discount_application.title === 'BF360GIFT' ? 'Free Spin Vortex' : allocation.discount_application.title, total_allocated_amount: allocation.amount}); }); });
    rows = rows.concat(cart.cart_level_discount_applications || []);
    return rows.filter(function (discount) { return discount.total_allocated_amount > 0; }).map(function (discount) {
      return '<div class="smart-cart-page-summary-row"><span>' + escapeHtml(discount.title) + '</span><strong>-' + formatMoney(discount.total_allocated_amount, currency) + '</strong></div>';
    }).join('');
  }

  function getCartDisplayTotal(cart) {
    return cart ? Number(cart.total_price) || 0 : 0;
  }

  function getCartCompareTotal(cart) {
    if (!cart || !cart.items || !cart.items.length) return 0;
    return cart.items.reduce(function (sum, item) {
      var unit = getItemDisplayUnitPrice(item);
      var compareAt = getVariantCompareAt(item.variant_id);
      if (compareAt <= unit) compareAt = unit;
      return sum + (compareAt * (Number(item.quantity || 1) || 1));
    }, 0);
  }

  function updateSummary(cart) {
    var currency = cart.currency || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    var original = document.querySelector('[data-smart-cart-page-original-total]');
    var itemTotal = document.querySelector('[data-smart-cart-page-item-total]');
    var savingsNode = document.querySelector('[data-smart-cart-page-savings]');
    var savingsRow = savingsNode ? savingsNode.closest('.smart-cart-page-summary-row--savings') : null;
    var total = document.querySelector('[data-smart-cart-page-total]');
    var discounts = document.querySelector('[data-smart-cart-page-discounts]');
    var displayTotal = getCartDisplayTotal(cart);
    var compareTotal = getCartCompareTotal(cart);
    var savings = Math.max(0, compareTotal - cart.items_subtotal_price);
    var itemTotalValue = Number(cart.original_total_price) || 0;

    if (original) original.textContent = formatMoney(displayTotal, currency);
    if (itemTotal) itemTotal.innerHTML = '<span class="price smart-cart-page-summary-price">' + formatMoney(itemTotalValue, currency) + '</span>';
    if (savingsNode) savingsNode.textContent = '-' + formatMoney(savings, currency);
    if (savingsRow) savingsRow.hidden = true;
    if (total) {
      total.innerHTML = '<span class="price smart-cart-page-total-current">' + formatMoney(displayTotal, currency) + '</span>';
    }
    if (discounts) {
      discounts.innerHTML = discountRowsHtml(cart, currency);
      discounts.hidden = !discounts.innerHTML;
    }
  }

  function renderEmptyCart() {
    var section = getSection();
    if (!section) return;

    var layout = section.querySelector('[data-smart-cart-page-layout]');
    var text = section.getAttribute('data-empty-text') || 'Your cart is currently empty.';
    var label = section.getAttribute('data-continue-shopping-label') || 'Continue shopping';
    var url = section.getAttribute('data-continue-shopping-url') || rootUrl() + 'collections/all';

    var emptyHtml = '<div class="smart-cart-page-empty" data-smart-cart-page-empty>' +
      '<p>' + escapeHtml(text) + '</p>' +
      '<p><a class="button smart-cart-page-empty-button" href="' + url + '">' + escapeHtml(label) + '</a></p>' +
      '</div>';

    if (layout) layout.outerHTML = emptyHtml;

    var recommendations = section.querySelector('[data-smart-cart-page-recommendations-section]');
    if (recommendations) recommendations.hidden = true;
  }

  function renderCartPage(cart) {
    if (!cart) return;

    var currency = cart.currency || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    var itemsWrap = document.querySelector('[data-smart-cart-page-items]');

    clearError();
    updateCartCount(cart);

    if (!cart.items || !cart.items.length) {
      renderEmptyCart();
      return;
    }

    if (itemsWrap) {
      itemsWrap.setAttribute('aria-rowcount', cart.items.length);
      itemsWrap.innerHTML = cart.items.map(function (item, index) {
        return itemHtml(item, index, currency);
      }).join('');
    }

    updateSummary(cart);
    loadCartRecommendations(cart);
  }

  function updateLine(button, line, quantity) {
    if (!line || isUpdating) return;

    isUpdating = true;
    clearError();
    setLineBusy(button, true);
    setAllControlsBusy(true);

    fetchJson(rootUrl() + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ line: Number(line), quantity: Math.max(0, Number(quantity) || 0) })
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (data) {
            throw new Error(data.description || data.message || 'Unable to update cart.');
          });
        }
        return response.json();
      })
      .then(function (cart) { return window.SmartBFCM ? window.SmartBFCM.reconcile(cart, false) : cart; })
      .then(function (cart) {
        renderCartPage(cart);
      })
      .catch(function (error) {
        console.error(error);
        showError(error.message || 'Unable to update cart. Please try again.');
      })
      .finally(function () {
        isUpdating = false;
        setAllControlsBusy(false);
        setLineBusy(button, false);
      });
  }


  function saveCartNote() {
    var note = document.querySelector('[data-smart-cart-page-form] textarea[name="note"]');
    if (!note) return Promise.resolve();

    return fetchJson(rootUrl() + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ note: note.value || '' })
    }).catch(function () {
      return null;
    });
  }

  function redirectToCheckoutWithDiscount(code) {
    var cleanCode = String(code || '').trim();
    if (!cleanCode) return false;

    saveCartNote().finally(function () {
      window.location.href = rootUrl() + 'discount/' + encodeURIComponent(cleanCode) + '?redirect=' + encodeURIComponent('/checkout');
    });

    return true;
  }

  document.addEventListener('submit', function (event) {
    var form = event.target && event.target.closest ? event.target.closest('[data-smart-cart-page-form]') : null;
    if (!form) return;

    var input = form.querySelector('[data-smart-cart-page-discount-input]');
    if (!input || !input.value.trim()) return;

    event.preventDefault();
    redirectToCheckoutWithDiscount(input.value);
  });

  document.addEventListener('DOMContentLoaded', function () {
    if (window.SmartBFCM) window.SmartBFCM.get().then(function (cart) { return window.SmartBFCM.reconcile(cart, true); }).then(renderCartPage).catch(function (error) { showError(error.message); });
    loadCartRecommendations();
  });

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-smart-cart-page-qty-action]');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    var line = button.getAttribute('data-line');
    var quantity = parseInt(button.getAttribute('data-quantity'), 10) || 0;
    var action = button.getAttribute('data-smart-cart-page-qty-action');

    if (action === 'plus') updateLine(button, line, quantity + 1);
    else if (action === 'minus') updateLine(button, line, quantity - 1);
    else if (action === 'remove') updateLine(button, line, 0);
  });
})();
